// extracted by mini-css-extract-plugin
module.exports = {"instructions":"Quiz_instructions__bdiu7","questionSection":"Quiz_questionSection__7WnyO","title":"Quiz_title__L14S9","confirmation":"Quiz_confirmation__WIBXY"};